<template>
    <b-card  class="rounded-0 mb-n3">
        <b-form-group label-cols-sm="4" label-cols-lg="4" label="Wohnortsichtbarkeit" label-for="text-Wohnsichtbarkeit">
            <b-input-group>
                <b-form-select :class="darkmode ? 'bg-dark text-light border-secondary' : ''" id="text-Wohnsichtbarkeit"
                    v-model="value.adresse.wohnortSichtbarkeit"
                    :options="wohnortsichtbarkeitOptions" 
                />
                <template v-slot:append>
                    <b-button v-b-popover.hover.topleft="'Legt fest, welche Daten deiner Adresse andere sehen können.'">
                        <img src="../assets/interface/hint.svg" 
                            class="mt-n1 mx-n1" 
                            style="filter:invert(1);height:1.2em" 
                        />
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>
        <b-form-group label-cols-sm="4" label-cols-lg="4" label="Strasse, Hausnummer" label-for="text-StrasHaus">
            <b-input-group>
                <b-form-input :class="darkmode ? 'bg-dark text-light border-secondary' : ''" id="text-StrasHaus" style="width:50%"
                    :disabled="value.adresse.wohnortSichtbarkeit <= 0" 
                    :state="validationStreet" 
                    v-model="value.adresse.strasse"
                />
                <b-form-input v-model="value.adresse.hausnummer" :class="darkmode ? 'bg-dark text-light border-secondary' : ''"
                    :disabled="value.adresse.wohnortSichtbarkeit <= 1"
                    :state="validationHouseNumber"
                />
            </b-input-group>
            <b-form-invalid-feedback :state="validationStreet && validationHouseNumber">
                Entweder Strasse und Hausnummer oder nur Strasse
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-cols-lg="4" label="Postleitzahl & Ort" label-for="text-PLZ">
            <b-input-group>
                <b-form-input id="text-PLZ" 
                    ref="textPlz" 
                    :class="darkmode ? 'bg-dark text-light border-secondary' : ''"
                    list="plz-list" 
                    :value="value.adresse.plz" 
                    :debounce="1000" 
                    @input="handlePLZ" :state="validationPLZ" 
                />
                <datalist id="plz-list">
                    <option v-for="(plz, i) in plzList" :key="i">{{ plz.plz }}</option>
                </datalist>
                <b-form-select ref="ort" style="width:42%" 
                    :class="darkmode ? 'bg-dark text-light border-secondary border-left-0 rounded-right' : 'border-left-0 rounded-right'"
                    v-model="selOrt" 
                    @change="value.adresse.ort = $event.ort; value.adresse.plz = $event.plz"
                    :state="validationOrt"
                >
                    <b-form-select-option v-for="(ort, i) in ortList" :key="i" :value="ort">
                        {{ort.ort}}
                    </b-form-select-option>
                </b-form-select>
            </b-input-group>
            <b-form-invalid-feedback>
                Kein falsches Format oder leere PLZ/Ort möglich
            </b-form-invalid-feedback>
        </b-form-group>

        <b-card v-if="!register" no-body :class="darkmode ? 'bg-dark text-light border-secondary mb-3' : 'mb-3'"  style="height:18em" >
            <div class="d-flex flex-row justify-content-between m-0">
                <b-button :disabled="!completed || loading" class="w-100" variant="primary"
                    style="height:2.5em;border-top-right-radius:0; border-bottom-right-radius:0; border-bottom-left-radius:0" 
                    @click="calcAddressHandler"
                >
                    Öffentlichen Marker neu berechnen
                    <b-spinner v-show="loading" small /> 
                </b-button>
                <b-button
                    style="height:2.5em;border-top-left-radius:0; border-bottom-left-radius:0; border-bottom-right-radius:0" 
                    v-b-popover.hover.topleft="'Berechnet deinen Öffentlichen Marker mit Hilfe deiner Adresseinstellungen neu.'"
                >
                    <img src="../assets/interface/hint.svg" 
                        class="mt-n1 mx-n1" 
                        style="filter:invert(1);height:1.2em" 
                    />
                </b-button>
            </div>
            <l-map ref="map"
                style="height:100%;width:100%" 
                :options="{zoomControl: false}"
                :zoom="zoom"
                :center="[user.adresse.lat, user.adresse.lng]"
                :maxBounds="bounds"
                :minZoom="7"
                :maxZoom="maxZoom"
                @update:zoom="zoom = $event;iconClass = 'markerIcon'" 
            >
                <l-tile-layer ref="tiles"
                    @ready="$event.on('tileerror', tileErrorHandler)"
                    :url="provider.url" 
                    :attribution="attribution"/>
                    <uebersicht-control-zoom
                        v-model="zoom"/>
                    <uebersicht-control-provider control
                        v-model="provider" />
                    <uebersicht-control-center/>
                    <uebersicht-marker-public
                        ref="mp2"/>
            </l-map>
        </b-card>
    </b-card>
</template>

<script>
import { Icon/* ,Routing */, latLng, latLngBounds } from 'leaflet'
import { mapGetters, mapActions } from 'vuex'
import { setAlert } from '../tools'
import UebersichtControlProvider from "../components/UebersichtControlProvider.vue"
import UebersichtControlZoom from "../components/UebersichtControlZoom.vue"
import { updateOrte } from '../store/apiHelper'
import { LMap, LTileLayer } from 'vue2-leaflet'
import { BCard, BSpinner, BInputGroup, BFormInput, BFormInvalidFeedback, BFormSelectOption, BFormSelect, VBPopover } from "bootstrap-vue"
import { tileProviders, attribution } from '../config'
import "leaflet/dist/leaflet.css"
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
export default {
    name: "EinstellungenAddressCard",
    components:{
        LMap,
        LTileLayer,
        BCard,
        BSpinner,
        BInputGroup, 
        BFormInput, 
        BFormInvalidFeedback, 
        BFormSelectOption,
        BFormSelect,
        UebersichtControlZoom,
        UebersichtControlProvider
    },
    directives:{
        'b-popover': VBPopover
    },
    props: {
        value: {},
        register: Boolean,
    },
    watch:{
        selOrt: function(){
            if(this.selOrt){
                this.value.adresse.ort = this.selOrt.ort
            }
        }
    },
    computed: {
        ...mapGetters(['schulAdresse', 'user', 'darkmode']),
        bounds: function () {
            if (this.schulAdresse)
                return latLngBounds(
                    latLng(this.schulAdresse.bounds.x.lat, this.schulAdresse.bounds.x.lng),
                    latLng(this.schulAdresse.bounds.y.lat, this.schulAdresse.bounds.y.lng)
                )
            else
                return null
        },
        plzList: (that) => that.orte.filter((x, i) => that.orte.findIndex(y => y.plz === x.plz) == i),
        ortList: (that) => that.orte.filter((x) => x.plz.includes(that.value.adresse.plz)),

        completed: (that) => that.validationStreet && that.validationHouseNumber && that.validationPLZ && that.validationOrt,
        validationStreet: (that) => that.value.adresse.strasse == null || that.value.adresse.strasse == '' || that.value.adresse.strasse.length > 2,
        validationHouseNumber: (that) => that.value.adresse.hausnummer == null || that.value.adresse.hausnummer == '' || that.value.adresse.hausnummer.length > 0 && that.value.adresse.strasse != '',
        validationPLZ: (that) => that.value.adresse.plz.length == 5,
        validationOrt: (that) => that.selOrt != undefined && that.value.adresse.plz == that.selOrt.plz
    },
    data() {
        return {
            wohnortsichtbarkeitOptions: [
                { value: 0, text: "nur Ort" },
                { value: 1, text: "Ort und Strasse" },
                { value: 2, text: "Ort, Strasse und Hausnummer" }
            ],
            regPLZ: /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/,
            orte: [],
            selOrt: undefined,
            zoom: 15,
            maxZoom: 18,
            provider: tileProviders[0],
            center: [49.912085, 12.189139],
            attribution: attribution,
            error: false,
            loading: false
        }
    },
    methods: {
        ...mapActions(['calcAddress']),
        showArrows(times){
            this.$refs.mp2.startArrows(times)
        },
        async calcAddressHandler(){
            this.loading = true
            try{
                await this.calcAddress()
                setAlert(this, "Marker erfolgreich berechnet", "Erfolg", "success")
            }
            catch (err) {
                setAlert(this, err.response.data, 'Setzen fehlgeschlagen', 'danger')
            }
            this.loading = false
        },
        // Behandelt Fallback, falls Map-Provider nicht verfügbar ist
        tileErrorHandler(){
            if(!this.provider != tileProviders[2] && !this.error){
                setAlert(this, "Map-Anbieter nicht verfügbar. Versuche den Anbieter auf OpenStreetMap zu ändern.", "Mitteilung", 'warning')
                this.error = true
            }
        },
        async handlePLZ(value) {
            this.value.adresse.plz = value
            try {
                this.orte = await updateOrte(this.value.adresse.plz)
                this.selOrt = this.orte.find(x => x.ort == this.value.adresse.ort)
                this.selOrt = this.selOrt ? this.selOrt : this.orte[0]
                this.selOrt = this.selOrt ? this.selOrt : {}
            }
            catch (err) {
                setAlert(this, err.response.data, 'Laden der Orte fehlgeschlagen', 'danger')
            }
        }
    },
    async mounted() {
        if(!this.register)
            this.$refs.map.mapObject.options.zoomSnap = 0.25
        this.orte = await updateOrte(this.value.adresse.plz)
        this.selOrt = this.orte.find(x => x.ort == this.value.adresse.ort)
        this.selOrt = this.selOrt ? this.selOrt : this.orte[0]
        this.selOrt = this.selOrt ? this.selOrt : {}
    }
}
</script>